export const formatCurrency = (value, options)=>{
    const USDollar = new Intl.NumberFormat('en-US', {
        currency: 'USD',
        maximumFractionDigits: options?.maximumFractionDigits,
        style: 'currency'
    });
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    return USDollar.format(isNaN(numericValue) ? 0 : numericValue);
};

//# sourceMappingURL=formatCurrency.js.map